const EmbeddedViewWidth = "100%"
const NormalViewWidth = "90%"

export const getViewWidth = (isEmbedded: boolean) => {
  return isEmbedded ? EmbeddedViewWidth : NormalViewWidth
}
